import React from 'react'
import { Tooltip, Typography } from '@mui/material'

interface TooltipProps {
  children
}

export default function AbstractDataGridTooltip(props: TooltipProps) {
  const { children } = props
  return (
    <Tooltip title={children} placement='top'>
      <Typography sx={{ fontSize: '12px', color: '#253140' }}>
        {children}
      </Typography>
    </Tooltip>
  )
}
